export enum BulkOperationEnum {
    CREATE_OPPORTUNITY_BY_EXPRESSION = 'CREATE_OPPORTUNITY_BY_EXPRESSION',
}
